import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useBlogApprovalRequestMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ blogId, emailContent }: { blogId: string; emailContent: Api.IRawRichTextContentState }) => {
			return userSession.webServiceHelper.callWebServiceAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `blog/${encodeURIComponent(blogId)}/approvalrequest`,
				}),
				'POST',
				emailContent
			);
		},
		onError,
		onSuccess,
	});
}
